import React from "react";
import styled from "styled-components";

import {
  FormGroup,
  Input as BootstrapInput,
  FormFeedback,
  Label,
  Col
} from "reactstrap";

const Input = props => {
  return <BootstrapInput {...props} />;
};

const renderInput = ({ input, meta, ...props }) => {
  const showError = meta.touched && meta.error;
  return (
    <FormGroup color={showError ? "danger" : ""}>
      <Input {...input} {...props} valid={showError ? false : undefined} />
      {showError && <Error>{meta.error}</Error>}
    </FormGroup>
  );
};

const renderInputWithLabel = ({
  input,
  meta,
  label,
  labelCol,
  inputCol,
  ...props
}) => {
  const showError = meta.touched && meta.error;
  return (
    <FormGroup color={showError ? "danger" : ""} row>
      <Label for={input.field} xs={labelCol || "3"}>
        {label}
      </Label>

      <Col xs={inputCol || "9"}>
        <Input {...input} {...props} valid={showError ? false : undefined} />
        {showError && <Error>{meta.error}</Error>}
      </Col>
    </FormGroup>
  );
};

const Error = styled(FormFeedback)`font-size: 12px;`;

export { Input, renderInput, renderInputWithLabel };



// WEBPACK FOOTER //
// ./src/components/Form/Input.js